export const BASE_URL = 'https://ulearn-10q2.onrender.com/';
export const COURSES_URL = '/api/v1/courses';
export const USERS_URL = '/api/v1/users';
export const CART_URL = '/api/v1/cart';
export const WISHLIST_URL = '/api/v1/wishlists';
export const ENROLLED_COURSES = '/api/v1/enrolled-courses';
